import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { putErrorNotification } from '../../../../../../../utils/saga';
import { initialize, initializeSuccess, initializeError } from '../actions';
import type {
  PapiDaDeviationInit,
  PapiRequestDaDeviationInit,
} from '@wix/da-papi-types';
import { getDeviationPageTypeFromTypeId } from '../../../../../../../Duperbrowse/redux/loader';

function* initializeSaga(action: ReturnType<typeof initialize>): SagaIterator {
  const {
    payload: { deviationId, username, typeId },
  } = action;

  const params: PapiRequestDaDeviationInit = {
    deviationid: deviationId,
    username,
    type: getDeviationPageTypeFromTypeId(typeId),
    include_session: false,
  };

  const response: PapiDaDeviationInit = yield call(
    requestPuppy,
    {
      method: 'get',
      url: '/init',
      params,
    },
    undefined,
    'dadeviation'
  );

  if (!response || !response.deviation || isApiError(response)) {
    const errorMessage = 'Failed to initialize boost';
    yield putErrorNotification(errorMessage);
    yield put(initializeError(errorMessage));

    return;
  }

  // Store the deviation directly in the boost modal store slice
  const payload = {
    deviation: response.deviation,
    tags: [],
    recommendedTags: [],
  };

  yield put(initializeSuccess(payload));
}

export default function* boostSaga() {
  yield takeEvery(initialize, initializeSaga);
}
